<template>
  <div class="flexgrid-demo">
    <Carousel
      :value="modules.filter((item) => item.isHeader === true)"
      isNew: true
      :responsiveOptions="responsiveOptions"
      :autoplayInterval="2000"
      circular
      :numVisible="1"
      :numScroll="1"
    >
      <!--       circular -->
      <template #item="slotProps">
        <router-link :to="slotProps.data.link">
          <img :src="slotProps.data.src" :alt="slotProps.data.alt" />
        </router-link>
      </template>
    </Carousel>
    <div class="cards">
      <div
        v-for="modulo in modules"
        :key="modulo.id"
        :class="['card p-col-12 p-md-12 p-lg-12 pointer', { 'card-with-label': modulo.isNew }]"
        @click="goTo(modulo.link)"
      >
        <a class="text-center">
          <img
            :src="modulo.image"
            :alt="modulo.title"
            style="width: 250px; height: 250px"
          />
        </a>
        <div class="content">
          <h2 class="p-text-bold text-color-grsm">{{ modulo.title }}</h2>
          <p>{{ modulo.description }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      modules: [
        {
          id: 7,
          src: "assets/layout/transparencia/banner.png",
          title: "Transparencia",
          description:
            "Información a disposición de la ciudadanía que permite conocer el nivel de cumplimiento regional en el portal de transparencia estandar.",
          image: "assets/layout/transparencia/logo-transparencia.png",
          link: "/publico/transparencia",
          isHeader: true,
          isNew: false
        },
        {
          id: 6,
          src: "assets/layout/salud/inclusion.png",
          title: "Inclusión e Igualdad",
          description:
            "Estos indicadores buscan identificar y cuantificar las barreras que pueden existir para grupos específicos de la población, con el fin de promover políticas y acciones que fomenten la inclusión y la igualdad.",
          image: "assets/layout/cards/inclusion.png",
          link: "/publico/inclusion",
          isHeader: true,
          isNew: false
        },
        {
          id: 1,
          src: "assets/layout/salud/salud.png",
          title: "Salud",
          description:
            "Estos indicadores proporcionan información importante sobre diversos aspectos de la salud, permitiendo a los profesionales de la salud y responsables de políticas tomar decisiones informadas y diseñar estrategias de intervención adecuadas",
          image: "assets/layout/cards/BUTON_SALUD.png",
          link: "/publico/salud",
          isHeader: true,
          isNew: false
        },
        {
          id: 2,
          src: "assets/layout/salud/educacion.png",
          title: "Educación",
          description:
            "Los indicadores de educación son medidas cuantitativas que se utilizan para evaluar y monitorear diversos aspectos del sistema educativo. Estos indicadores proporcionan datos objetivos y medibles sobre el estado, el progreso y la calidad de la educación en diferentes niveles, desde el nivel nacional hasta el nivel escolar.",
          image: "assets/layout/cards/BUTON_EDUCACION.png",
          link: "/publico/educacion",
          isHeader: true,
          isNew: false
        },
        {
          id: 3,
          src: "assets/layout/salud/presupuesto.png",
          title: "Presupuesto",
          description:
            "Estos indicadores proporcionan información cuantitativa sobre cómo se asignan, gastan y controlan los recursos financieros, y permiten evaluar la eficiencia, la efectividad y la transparencia del presupuesto.",
          image: "assets/layout/cards/BUTON_PRESUPUESTO1.png",
          link: "/publico/presupuesto",
          isHeader: true,
          isNew: false
        },
        {
          id: 4,
          src: "assets/layout/salud/saneamientos.png",
          title: "Saneamiento",
          description:
            "Son medidas utilizadas para evaluar y monitorear el acceso, la calidad y la cobertura de los servicios de saneamiento básico en una determinada área geográfica o población. Permiten identificar brechas, desafíos y áreas de mejora en este ámbito.",
          image: "assets/layout/cards/BUTON_SANEAMIENTO.png",
          link: "/publico/saneamiento",
          isHeader: true,
          isNew: false
        },
        { 
          id: 5,
          src: "assets/layout/salud/portada_principal.png",
          title: "DRTC - San Martín",
          description:
            "La Dirección Regional de Transportes y Comunicaciones es la entidad encargada de regular, supervisar y promover el desarrollo del transporte y las comunicaciones en la región.",
          image: "assets/layout/transportes/transporte.png",
          link: "/publico/drtc",
          isHeader: false,
          isNew: true
        },
         { 
          id: 8,
          src: "assets/layout/desarrollo-social/ICON_GRDS.png",
          title: "Gerencia de Desarrollo Social",
          description:
            "Órgano encargado de formular y ejecutar políticas públicas regionales en salud, educación, vivienda, trabajo, población e igualdad de oportunidades",
          image: "assets/layout/desarrollo-social/ICON_GRDS.png",
          link: "/publico/desarrollo",
          isHeader: false,
          isNew: true
        },
        {
          id: 999,
          src: "assets/layout/salud/portada_principal.png",
          title: "Ingresa al aplicativo",
          description:
            "Si eres un trabajador del Gobierno Regionsal San Martín ingresa para navegar por indicadores más detallados de cada rubro.",
          image: "assets/layout/cards/LOGO_GSObservatorio.png",
          link: "/login",
          isHeader: true,
          isNew: false
        },
      
      ],

      responsiveOptions: [
        {
          breakpoint: "1199px",
          numVisible: 1,
          numScroll: 1,
        },
        {
          breakpoint: "991px",
          numVisible: 1,
          numScroll: 1,
        },
        {
          breakpoint: "767px",
          numVisible: 1,
          numScroll: 1,
        },
      ],
    };
  },
  methods: {
    goTo(link) {
      this.$router.push({
        path: link,
      });
    },
  },
  mounted() {
    localStorage.setItem("header", JSON.stringify(true));
  },
  name: "GridDemo",
};
</script>

<style lang="scss">
.card-with-label {
  position: relative;
  overflow: hidden;

  &::before {
    content: "Nuevo";
    position: absolute;
    top: 7px;
    right: -20px;
    background: #822737;
    color: #ffffff;
    padding: 5px 20px;
    transform: rotate(45deg);
    z-index: 1000;
  }
}
/* .container {
  max-width: 1200px;
  margin: 0 auto;
} */

.cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-left: 20px;
  margin-right: 20px;
}

.fullscreen-carousel .p-carousel-content {
  width: 100%;
}

img {
  width: 100%;
}
.flexgrid-demo {
  background: #ffffff;
  .box {
    background-color: #ffffff;
    text-align: center;
    padding-top: 1rem;
    padding-bottom: 1rem;
    border-radius: 4px;
    box-shadow: 0 2px 1px -1px rgba(0, 0, 0, 0.2),
      0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 1px 3px 0 rgba(0, 0, 0, 0.12);
  }

  .box-stretched {
    height: 100%;
  }

  .vertical-container {
    margin: 0;
    height: 200px;
    background: #dee2e6;
    border-radius: 4px;
  }

  .nested-grid .p-col-4 {
    padding-bottom: 1rem;
  }

  .dynamic-box-enter-active,
  .dynamic-box-leave-active {
    transition: all 0.5s;
  }

  .dynamic-box-enter-from,
  .dynamic-box-leave-to {
    opacity: 0;
  }

  .dynamic-box-enter-from,
  .dynamic-box-leave-to {
    transform: translateX(30px);
  }

  p {
    margin: 0;
  }
}

.text-color-grsm {
  color: #822737;
}

.pointer {
  cursor: pointer;
}
</style>
